import React, { FC } from 'react';
import PlaceHolder from '../../assets/images/Redwood-Forest.jpg';

interface Props {
  image: string;
}

const ProgramImage: FC<Props> = ({ image }) => {
  const imageUrl = image?.includes('placeholder')
    ? `url(${PlaceHolder})`
    : image;
  return <img alt="program" crossOrigin="anonymous" className="programImage__containerImage pdf-image" src={imageUrl} />;
};
export default ProgramImage;
